import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import cx from 'classnames';
import { Row, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import Modal from '../../../Basic/Modal';
import Notification from '../../../Basic/Notification';
import UserOption, { filterOption as userFilterOption } from '../SolutionManagement/userOption.component';
import CommonSelect from '../../../Basic/Select';
import CommonLoad from '../../../Basic/Spin';
import { assignSubscription } from '../../api/subscriptionManagement.api';
import { assignUserApi } from '../../api/solutionManagement.api';
import { updateUserApi, getUserList } from '../../api/accountSetting.api';
var TARGET_NAME = 'LicensedObject';

var SubscriptionEditModal = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SubscriptionEditModal, _React$PureComponent);

  var _super = _createSuper(SubscriptionEditModal);

  function SubscriptionEditModal(props) {
    var _this;

    _classCallCheck(this, SubscriptionEditModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onObjectNameChange", function (item) {
      _this.setState({
        checkedValue: item,
        canSave: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validateFields", function () {
      _this.setState({
        canSubmit: true,
        finalValidationsFailed: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, editLicenseDetail, editTargetID, translate, licensedUser, licensedAsset, slnRoleID, licenseType, parentID, checkedValue, message, id, givenName, surname, email, sfxRoles, oldUser, _yield$getUserList, userInfoList, userInfo, assignedSolutions, solutionRoleIds, result, newData;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, editLicenseDetail = _this$props.editLicenseDetail, editTargetID = _this$props.editTargetID, translate = _this$props.translate;
              licensedUser = editLicenseDetail.licensedUser, licensedAsset = editLicenseDetail.licensedAsset, slnRoleID = editLicenseDetail.slnRoleID, licenseType = editLicenseDetail.licenseType, parentID = editLicenseDetail.parentID;
              checkedValue = _this.state.checkedValue;

              _this.setState({
                saveLoading: true
              });

              message = licensedUser || licensedAsset ? translate('SFxAccountSettingsSubscriptionTransferType') : translate('SFxAccountSettingsSubscriptionAssignedType');
              _context.prev = 5;

              if (!(licenseType === 'User')) {
                _context.next = 25;
                break;
              }

              if (!licensedUser) {
                _context.next = 20;
                break;
              }

              id = licensedUser.id, givenName = licensedUser.givenName, surname = licensedUser.surname, email = licensedUser.email, sfxRoles = licensedUser.sfxRoles;
              oldUser = {
                id: id,
                orgId: editLicenseDetail.accountID,
                givenName: givenName,
                surname: surname,
                userName: email,
                solutionRoleIds: [],
                UserSubscriptionIdsToBeUsed: [],
                UserSubscriptionIdsToBeUnlinked: [editTargetID],
                sfxRoleIds: sfxRoles.map(function (i) {
                  return i.id;
                })
              };
              _context.next = 12;
              return getUserList({
                terms: email,
                Size: 10,
                Index: 1,
                orderBy: 'UserName',
                orderDirection: 'asc'
              });

            case 12:
              _yield$getUserList = _context.sent;
              userInfoList = _yield$getUserList.data.rows;
              userInfo = userInfoList.find(function (i) {
                return i.email === email;
              });
              assignedSolutions = userInfo.assignedSolutions;
              solutionRoleIds = assignedSolutions.map(function (i) {
                return i.roles;
              }).flat().map(function (r) {
                return r.id;
              }).filter(function (i) {
                return i !== slnRoleID;
              });
              oldUser.solutionRoleIds = solutionRoleIds;
              _context.next = 20;
              return updateUserApi(oldUser);

            case 20:
              result = [{
                UserId: checkedValue.id,
                SolutionId: parentID,
                RoleIds: [],
                UserSubscriptionIdsToBeUsed: [editTargetID],
                UserSubscriptionIdsToBeUnlinked: []
              }];
              _context.next = 23;
              return assignUserApi(result);

            case 23:
              _context.next = 29;
              break;

            case 25:
              newData = _objectSpread(_objectSpread({}, editLicenseDetail), {}, {
                licensedObjectID: checkedValue.value
              });

              if (!checkedValue.value) {
                message = translate('SFxAccountSettingsSubscriptionUnassignedType');
                delete newData.licensedObjectID;
              }

              _context.next = 29;
              return assignSubscription(newData);

            case 29:
              _this.setState({
                saveLoading: false
              });

              _this.props.successCallback(parentID);

              Notification.open({
                description: _this.props.translate('SFxAccountSettingsSubscriptionOptionMsg', message)
              });
              _context.next = 38;
              break;

            case 34:
              _context.prev = 34;
              _context.t0 = _context["catch"](5);
              console.log(_context.t0);

              _this.setState({
                saveLoading: false
              });

            case 38:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 34]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      _this.props.onClose();
    });

    _defineProperty(_assertThisInitialized(_this), "onToggle", function () {
      _this.props.toggleModal();
    });

    var _editLicenseDetail = _this.props.editLicenseDetail;
    var _licensedUser = _editLicenseDetail.licensedUser,
        _licensedAsset = _editLicenseDetail.licensedAsset,
        _licenseType = _editLicenseDetail.licenseType,
        licensedObjectID = _editLicenseDetail.licensedObjectID;
    var assetInitValue = _licensedAsset && {
      Name: _licensedAsset.Name,
      ObjectID: licensedObjectID
    };

    var _checkedValue = _licenseType === 'User' ? _licensedUser : assetInitValue;

    _this.state = {
      formSubmitting: false,
      finalValidationsFailed: false,
      isNameEmpty: false,
      canSubmit: false,
      checkedValue: _checkedValue,
      isValueChanged: false,
      operationType: '',
      confirmTarget: '',
      saveLoading: false,
      canSave: false
    };
    return _this;
  }

  _createClass(SubscriptionEditModal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefix = _this$props2.prefix,
          translate = _this$props2.translate,
          editLicenseDetail = _this$props2.editLicenseDetail,
          modalSelect = _this$props2.modalSelect;
      var licenseType = editLicenseDetail.licenseType,
          linkedSolution = editLicenseDetail.linkedSolution;
      var footer = /*#__PURE__*/React.createElement(React.Fragment, null, licenseType !== 'User' && /*#__PURE__*/React.createElement("span", {
        className: 'reminder'
      }, translate('SFxAccountSettingsUnassignSubscriptionsMessage')), /*#__PURE__*/React.createElement(Button, {
        color: "secondary",
        onClick: this.onClose,
        className: 'cancel'
      }, translate('SFxAccountSettingsCancelButtonText')), /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        className: "save",
        disabled: !this.state.canSave,
        onClick: this.onSave
      }, translate('SFxAccountSettingsSaveButtonText')));
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.props.isOpen,
        centered: true,
        title: translate('SFxAccountSettingsSubscriptionModalTitle'),
        toggle: this.onToggle,
        backdrop: "static",
        className: cx("account-settings-modal", "subscription-modal"),
        footer: footer
      }, this.state.saveLoading && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-mask")
      }, /*#__PURE__*/React.createElement(CommonLoad, {
        size: 0.2
      })), /*#__PURE__*/React.createElement(Form, {
        className: "edit-form"
      }, licenseType === 'User' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(FormGroup, {
        className: "col-lg-6"
      }, /*#__PURE__*/React.createElement("p", {
        className: "subTitle"
      }, translate('SFxAccountSettingsAssignSubscriptionToUser')), /*#__PURE__*/React.createElement(Label, {
        for: TARGET_NAME,
        className: "label"
      }, translate('SFxAccountSettingsSubscribedUser')), /*#__PURE__*/React.createElement(CommonSelect, {
        id: TARGET_NAME,
        name: TARGET_NAME,
        value: this.state.checkedValue,
        options: modalSelect.options,
        renderOption: function renderOption(i) {
          return {
            label: i.email,
            value: i.id
          };
        },
        filterOption: userFilterOption,
        components: {
          Option: UserOption
        },
        onChange: this.onObjectNameChange,
        isLoading: modalSelect.loading
      }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(FormGroup, {
        className: "col-lg-6"
      }, /*#__PURE__*/React.createElement(Label, {
        className: "label"
      }, "Solution"), /*#__PURE__*/React.createElement(Input, {
        readOnly: true,
        value: linkedSolution && linkedSolution.SolutionName
      })), /*#__PURE__*/React.createElement(FormGroup, {
        className: "col-lg-6"
      }, /*#__PURE__*/React.createElement(Label, {
        className: "label"
      }, "Solution Role"), /*#__PURE__*/React.createElement(Input, {
        readOnly: true,
        value: linkedSolution && linkedSolution.RoleName
      })))) : /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(FormGroup, {
        className: "col-lg-6"
      }, /*#__PURE__*/React.createElement("p", {
        className: "subTitle"
      }, translate('SFxAccountSettingsAssignSubscriptionToAsset')), /*#__PURE__*/React.createElement(Label, {
        for: TARGET_NAME,
        className: "label"
      }, translate('SFxAccountSettingsSubscribedAsset')), /*#__PURE__*/React.createElement(CommonSelect, {
        id: TARGET_NAME,
        name: TARGET_NAME,
        value: this.state.checkedValue,
        options: modalSelect.options,
        renderOption: function renderOption(i) {
          return {
            label: i.Name,
            value: i.ObjectID
          };
        },
        onChange: this.onObjectNameChange,
        isLoading: modalSelect.loading
      })))));
    }
  }]);

  return SubscriptionEditModal;
}(React.PureComponent);

export default SubscriptionEditModal;